var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocColorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.36,
    height: 22.76,
    viewBox: "0 0 17.36 22.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DOCX",
    transform: "translate(-1 -0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M18.35,22.08a.681.681,0,0,1-.67.69H1.67A.681.681,0,0,1,1,22.08V.7A.681.681,0,0,1,1.67.01H13.48c.87.93,4.51,4.47,4.88,4.94V22.07Z",
    fill: "#e0f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M18.35,15.86H1v6.2a.681.681,0,0,0,.67.69H17.69a.681.681,0,0,0,.67-.69V15.87Z",
    fill: "#1e95c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M13.51.02V4.31a.628.628,0,0,0,.62.61h4.18Z",
    fill: "#99badb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1710",
    "data-name": "Rectangle 1710",
    width: 9,
    height: 1,
    rx: 0.45,
    transform: "translate(3.35 6.31)",
    fill: "#1e95c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711",
    "data-name": "Rectangle 1711",
    width: 9,
    height: 1,
    rx: 0.5,
    transform: "translate(3.35 9.31)",
    fill: "#1e95c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712",
    "data-name": "Rectangle 1712",
    width: 5,
    height: 1,
    rx: 0.5,
    transform: "translate(3.35 12.31)",
    fill: "#1e95c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M5.37,21.26V17.98h.97a1.643,1.643,0,0,1,.6.11,1.376,1.376,0,0,1,.47.31,1.348,1.348,0,0,1,.3.49,1.868,1.868,0,0,1,.11.64v.16a1.826,1.826,0,0,1-.11.64,1.438,1.438,0,0,1-.3.49,1.245,1.245,0,0,1-.47.31,1.754,1.754,0,0,1-.62.11H5.38Zm.57-2.82V20.8h.37a1.07,1.07,0,0,0,.41-.08.7.7,0,0,0,.29-.22.819.819,0,0,0,.17-.35,2.136,2.136,0,0,0,.06-.46v-.17a1.242,1.242,0,0,0-.23-.81.82.82,0,0,0-.67-.28h-.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M11,19.71a2.007,2.007,0,0,1-.1.67,1.512,1.512,0,0,1-.28.5,1.243,1.243,0,0,1-.43.32,1.43,1.43,0,0,1-1.1,0,1.13,1.13,0,0,1-.43-.32,1.512,1.512,0,0,1-.28-.5,2.007,2.007,0,0,1-.1-.67v-.17a2.007,2.007,0,0,1,.1-.67,1.418,1.418,0,0,1,.28-.5,1.243,1.243,0,0,1,.43-.32,1.421,1.421,0,0,1,.55-.11,1.471,1.471,0,0,1,.56.11,1.13,1.13,0,0,1,.43.32,1.62,1.62,0,0,1,.28.5,2.3,2.3,0,0,1,.1.67v.17Zm-.57-.17a2.461,2.461,0,0,0-.05-.49.947.947,0,0,0-.15-.35.628.628,0,0,0-.25-.21.884.884,0,0,0-.33-.07.685.685,0,0,0-.58.28,1.032,1.032,0,0,0-.16.35,1.775,1.775,0,0,0-.06.49v.17a1.826,1.826,0,0,0,.06.49,1.032,1.032,0,0,0,.16.35.751.751,0,0,0,.25.22.725.725,0,0,0,.33.07.668.668,0,0,0,.58-.29,1.487,1.487,0,0,0,.2-.84v-.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M14.07,20.2a1.239,1.239,0,0,1-.11.44.976.976,0,0,1-.25.35,1.09,1.09,0,0,1-.39.23,1.442,1.442,0,0,1-.53.08,1.421,1.421,0,0,1-.55-.11,1.18,1.18,0,0,1-.42-.31,1.446,1.446,0,0,1-.27-.49,2.105,2.105,0,0,1-.09-.64v-.27a2.105,2.105,0,0,1,.09-.64,1.374,1.374,0,0,1,.27-.49,1.149,1.149,0,0,1,.42-.31,1.434,1.434,0,0,1,.56-.11,1.669,1.669,0,0,1,.52.08,1.1,1.1,0,0,1,.38.23,1.16,1.16,0,0,1,.25.36,1.351,1.351,0,0,1,.11.45h-.57a1.154,1.154,0,0,0-.06-.28.719.719,0,0,0-.12-.21.464.464,0,0,0-.2-.13.853.853,0,0,0-.3-.05.739.739,0,0,0-.34.07.611.611,0,0,0-.24.21,1.339,1.339,0,0,0-.15.34,1.622,1.622,0,0,0-.05.46v.27a2.154,2.154,0,0,0,.04.45,1.049,1.049,0,0,0,.13.34.689.689,0,0,0,.23.22.712.712,0,0,0,.34.08.934.934,0,0,0,.31-.04.539.539,0,0,0,.34-.34,1.907,1.907,0,0,0,.07-.28h.57Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocColorIcon);
export default __webpack_public_path__ + "static/media/doc-color-icon.653f41aa40081cbe38ce65cf52a6877c.svg";
export { ForwardRef as ReactComponent };